// import { useState } from "react";
import { Link } from "react-router-dom";
import { GetContratos } from "../../actions/contratot.jsx";
import { GotoLogin } from "../../actions/renovarLog.jsx";
import style from "../../styles/grid.module.css";
import { useMutation } from "@tanstack/react-query";
// import { FcDeleteRow,FcAbout  } from "react-icons/fc";
import { Eye, SquareX, CirclePlus } from "lucide-react";

export default function Contratosp() {
   const token = localStorage.getItem("token");
   const url = process.env.REACT_APP_URL_DIR + "contratotattoo";

   const data = GetContratos();

   const formatDate = (fecha) => {
      var newDate1 = fecha.substring(0, 10).split("-");
      var newdate2 = newDate1[2] + "/" + newDate1[1] + "/" + newDate1[0];
      return newdate2;
   };
   const { mutate } = useMutation({
      mutationFn: (id) =>
         fetch(url + "/" + id, {
            method: "DELETE",
            body: JSON.stringify(),
            headers: {
               Authorization: `Bearer ${token}`,
               "Content-Type": "application/json",
            },
         }).then((res) => res.json()),
      onSuccess: (res) => {
         if (res?.message) {
            alert(`Aviso : ${res.message}`);
         }
         window.location.href = "/contratot";
      },
      onError: () => {
         alert("Error");
      },
   });

   // function handleInputChange(e) {
   //    if (e.key === "Enter") {
   //       // dispatch(GetContratosByName(usr, nombre));
   //       console.log('clientes: ', nombre);
   //       setName("");
   //    }
   // }

   const handleRemove = (id) => {
      let text =
         "Se va a eliminar el Cliente selecionado!\nSelecione Aceptar or Cancelar.";
      if (window.confirm(text) === true) {
         mutate(id);
      }
   };

   if (data?.message === "Token inválido") {
      return <GotoLogin />;
   }

   console.log("data contratos: ", data);
   return (
      <div className={style.tableCli}>
         <div>
            <div>
               <div className={style.gridTitle}>
                  <h2>Contratos de Tattoo</h2>
               </div>
            </div>
            <div>
               <div>
                  <Link
                     to={"/ContratotattooDir/2"}
                     className="dLink"
                     title="Alta Contrato Tattoo"
                     state={{
                        id: 0,
                     }}
                  >
                     {" "}
                     <CirclePlus className="lucidePlus" />
                     {/* <button className={style.inputBtnNew}>Alta Cliente</button> */}
                  </Link>
                  &nbsp;&nbsp;
               </div>
            </div>
         </div>
         <br />
         <div>
            <table className={style.gridTable}>
               <thead>
                  <tr style={{ background: "#eee" }}>
                     <th
                        className={style.solopc}
                        style={{ border: "1px solid #ccc", padding: "8px" }}
                     >
                        ID
                     </th>
                     <th style={{ border: "1px solid #ccc", padding: "8px" }}>
                        Fecha
                     </th>
                     <th
                        className={style.solopc}
                        style={{ border: "1px solid #ccc", padding: "8px" }}
                     >
                        Documento
                     </th>
                     <th style={{ border: "1px solid #ccc", padding: "8px" }}>
                        Nombre
                     </th>
                     <th style={{ border: "1px solid #ccc", padding: "8px" }}>
                        Accion
                     </th>
                  </tr>
               </thead>
               <tbody>
                  {data?.contratos.map((contrato) => {
                     console.log(
                        "contrato.nombreCompleto: ",
                        contrato.nombreCompleto
                     );

                     return (
                        <tr key={contrato.id_primary}>
                           <td
                              className={style.solopc}
                              style={{
                                 border: "1px solid #ccc",
                                 padding: "8px",
                              }}
                           >
                              {contrato.id_primary}
                           </td>
                           <td
                              style={{
                                 border: "1px solid #ccc",
                                 padding: "8px",
                              }}
                           >
                              {formatDate(contrato.updatedAt)}
                           </td>
                           <td
                              className={style.solopc}
                              style={{
                                 border: "1px solid #ccc",
                                 padding: "8px",
                              }}
                           >
                              {contrato.dni}
                           </td>
                           <td
                              style={{
                                 border: "1px solid #ccc",
                                 padding: "8px",
                              }}
                           >
                              {contrato.apellido}
                           </td>
                           <td
                              style={{
                                 border: "1px solid #ccc",
                                 padding: "8px",
                              }}
                           >
                              <Link
                                 title="Ver Contrato"
                                 to={"/ContratotattooExt"}
                                 state={{
                                    id: contrato.id_primary,
                                 }}
                              >
                                 <Eye className="lucideIcon" />
                              </Link>
                              &nbsp;&nbsp;
                              <span
                                 className="lucideIconDel"
                                 title="Eliminar Contrato"
                              >
                                 <SquareX
                                    className="lucideIconDel"
                                    onClick={() =>
                                       handleRemove(contrato.id_primary)
                                    }
                                 />
                              </span>
                           </td>
                        </tr>
                     );
                  })}
               </tbody>
            </table>
         </div>
      </div>
   );
}
